import {useEffect, useState} from "react";
import {useSelector} from "react-redux"
import "../../../index.css"
import {getExtraPodcastParameters} from "../../utils/action"
import {useDispatch} from "react-redux"
const EditToggle = () => {
    const dispatch = useDispatch();
    const thumb = useSelector((state) => state.ReducerGetPodcastData.secondThumbData);
    const podItems = useSelector((state) => state.ReducerGetPodcastData.podcastItems_byId);
    let titleItems = podItems?.map(podcast => podcast.title).join("");
    let descrItems = podItems?.map(podcast => podcast.description).join("");
    let thumbnail = podItems?.map(podcast => podcast.vignette).join("");
    const audio = podItems?.map(podcast => podcast.audio).join("");
    const id = podItems?.map(podcast => podcast.id).join("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [vignette, setVignette] = useState("");
    useEffect(() => {
        setTitle(titleItems);
        setDescription(descrItems);
        setVignette(thumbnail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [podItems]);

    useEffect(() => {
        if (thumb) {
            setVignette(thumb)
        }
     // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [thumb])
    useEffect(() => {
    dispatch(getExtraPodcastParameters(title, description, vignette, audio, audio, id))
     // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title, description, vignette])
   
}

export default EditToggle;
